import { UserPresence } from "@/hooks/useSessionPresence";

export interface CommitBlockerResult {
  canCommit: boolean;
  activeEditors: UserPresence[];
  warningMessage: string | null;
}

/**
 * Checks if other users are actively editing before allowing a commit.
 * Returns a warning if active users are present (within the last 2 minutes).
 */
export function useCommitBlocker(
  activeUsers: UserPresence[]
): CommitBlockerResult {
  // Filter users who were active in the last 2 minutes
  const twoMinutesAgo = new Date(Date.now() - 2 * 60 * 1000).toISOString();

  const activeEditors = activeUsers.filter(
    (u) => u.online_at >= twoMinutesAgo
  );

  if (activeEditors.length === 0) {
    return {
      canCommit: true,
      activeEditors: [],
      warningMessage: null,
    };
  }

  const names = activeEditors
    .map((u) => u.name || u.email?.split("@")[0] || "Unbekannt")
    .join(", ");

  return {
    canCommit: false, // UI should show warning + "trotzdem fortfahren"
    activeEditors,
    warningMessage: `${names} ${
      activeEditors.length === 1 ? "bearbeitet" : "bearbeiten"
    } gerade diese Entscheidung. Offene Änderungen könnten verloren gehen.`,
  };
}
